import { createBrowserRouter, RouterProvider, Navigate, redirect, Outlet } from 'react-router-dom';
import Order from './components/Options/Order';
import OrderBusiness from './components/Options/OrderBusiness';
import ActivationRequest from './components/Options/ActivationRequest';

const validLanguages = ['de', 'en'];

const validateLanguage = (lang) => {
  if (!validLanguages.includes(lang)) {
    throw redirect('/de');
  }
  return null;
};

const router = createBrowserRouter([
  {
    path: "/:lang",
    element: <Outlet />,
    loader: ({ params }) => validateLanguage(params.lang),
    children: [
      {
        path: "",
        element: <Order />,
      },
      {
        path: "order",
        element: <Order />,
      },
      {
        path: "activate-charging-cards",
        element: <ActivationRequest />,
      },
      {
        path: "activation-request",
        element: <ActivationRequest />,
      },
    ],
  },
  {
    path: "/business",
    element: <OrderBusiness />,
  },
  {
    path: "*",
    element: <Navigate to="/de" />,
  },
]);

function App() {
  return (
    <div className="App container-fluid bg-appBackground py-5 px-5 min-h-screen">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
